import CategoryChip from './CategoryChip'

export default CategoryChip
